<!-- Video player -->
<!-- YT Video, iFrame is for YT player -->
<div
  class="video-player"
  *ngIf="safeUrl && !isVimeo"
  [ngStyle]="{ display: playVideo ? 'block' : 'none' }"
>
  <iframe
    class="video-frame"
    width="100%"
    height="100%"
    [src]="safeUrl"
    modestbranding="0"
    controls="0"
    frameborder="0"
    allow="accelerometer; autoplay; modestbranding; encrypted-media; gyroscope; picture-in-picture"
    webkitAllowFullScreen
    mozallowfullscreen
    allowFullScreen
    #videoFrame
  ></iframe>
</div>

<!-- VIMEO video, iFrame will be created by Vimeo plugin -->
<div
  class="video-player"
  id="vimeoPlayer"
  #vimeoPlayer
  *ngIf="isVimeo && safeUrl"
  [ngStyle]="{ display: playVideo ? 'block' : 'none' }"
></div>

<!-- Video Player thumbnail -->
<!-- Set playVideo to true, after click -->
<div class="video-player" *ngIf="!playVideo" (click)="playVideoNow()">
  <ion-button>
    <ion-icon
      slot="icon-only"
      name="play"
      shape="round"
      color="light"
    ></ion-icon>
  </ion-button>
  <!-- Thumbnail images fetched from api -->
  <!-- if high res (2x) not found switch to low res -->
  <img
    *ngIf="thumbnails"
    [src]="
      thumbnails?.thumbnail2x ? thumbnails.thumbnail2x : thumbnails.thumbnail
    "
  />
</div>
